enum AlertTypeEnum {
  Info = "_alert_info",
  Warning = "_alert_warning",
  Error = "_alert_error",
  Question = "_alert_question",
}

export default AlertTypeEnum;
